import { useState } from 'react';
import { ImageIcon } from 'lucide-react';
import { supabase } from '@/lib/supabase';
import { useUserStore } from '@/store/userStore';
import { useTelegram } from '@/hooks/useTelegram';

/**
 * Превью блюд в дневнике — по желанию человека.
 *
 * По умолчанию ВЫКЛЮЧЕНО намеренно. Снимки еды — личное: в кадр попадают кухня,
 * дети, чужие лица. Хранить их молча нельзя, а спрашивать один раз честно.
 * В политике поэтому формулировка «сохраняем уменьшенную копию, если ты включил».
 *
 * Хранится миниатюра 200×200 (~15 КБ), не исходный снимок: узнать блюдо можно,
 * а случайное лицо в углу кадра на таком размере превращается в пиксели.
 */
export function MealPhotosCard() {
  const { profile, setProfile } = useUserStore();
  const { haptic } = useTelegram();
  const [busy, setBusy] = useState(false);
  const on = !!(profile as any)?.save_meal_photos;

  async function toggle() {
    if (!profile?.id || busy) return;
    setBusy(true);
    haptic('light');
    const next = !on;
    setProfile({ ...profile, save_meal_photos: next } as any);
    const { error } = await supabase
      .from('profiles').update({ save_meal_photos: next }).eq('id', profile.id);
    if (error) {
      setProfile({ ...profile, save_meal_photos: on } as any); // не записалось — вернули
      haptic('error');
    }
    setBusy(false);
  }

  return (
    <div className="bg-bg-card rounded-2xl p-4 mb-4 border border-line">
      <div className="flex items-center gap-2 mb-1">
        <ImageIcon className="w-4 h-4 text-sky-glow" aria-hidden />
        <span className="text-sm font-medium text-ink">Фото блюд в дневнике</span>
      </div>
      <p className="text-[11px] text-ink-dim mb-3 leading-snug">
        Сохранять маленькое превью снятой еды, чтобы узнавать приёмы в дневнике по картинке.
        Хранится уменьшенная копия, не исходный снимок.
      </p>
      <button
        onClick={toggle}
        disabled={busy}
        className={`w-full py-2.5 rounded-xl text-sm border transition-colors disabled:opacity-50 ${
          on
            ? 'text-sky-glow bg-sky-glow/10 border-sky-glow/30'
            : 'text-ink-muted border-line'
        }`}
      >
        {on ? 'Превью сохраняются' : 'Не сохранять'}
      </button>
    </div>
  );
}
